import React, { useEffect, useMemo, useRef, useState } from 'react';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import debounce from 'components/Dashboard/helpers/debounce';

const RecipientsSearchBar = ({ searchValue, setSearchValue }) => {
  const inputSearch = useRef(null);
  const isSmallMobile = useIsMobile(480);
  const [localSearchValue, setLocalSearchValue] = useState(searchValue);

  const debouncedSetSearchValue = useMemo(() => debounce(setSearchValue, 300), [setSearchValue]);

  useEffect(() => {
    setLocalSearchValue(searchValue);
  }, [searchValue]);

  useEffect(() => {
    return () => {
      debouncedSetSearchValue.cancel();
    };
  }, [debouncedSetSearchValue]);

  return (
    <div className='position-relative recipient-search-bar rounded-pill'>
      <div className={'flex-centered simple-searchbar-open-influence simple-searchbar-influence'}>
        <span className={`icon-search title-h5-m`} style={{ margin: '2px 11px 0 -1px', color: '#9c9c9c' }} />
        <div className='flex-grow-1'>
          <input
            className={`search-main-input w-100`}
            data-hj-allow
            type='text'
            value={localSearchValue}
            onChange={(e) => {
              const nextValue = e.target.value;
              setLocalSearchValue(nextValue);
              debouncedSetSearchValue(nextValue);
            }}
            spellCheck={false}
            ref={inputSearch}
            placeholder={isSmallMobile ? 'Search' : 'Search for a contact'}
          />
        </div>
        <div
          className='close-icon-container'
          style={{
            visibility: searchValue !== '' ? 'visible' : 'hidden',
          }}
        >
          <button
            data-testid='recipients-search-clear'
            className='general-button close-icon'
            data-tooltip-content='Clear search'
            data-tooltip-id='general-tooltip'
            data-tooltip-place='right'
            onClick={(e) => {
              e.stopPropagation();
              debouncedSetSearchValue.cancel();
              setLocalSearchValue('');
              setSearchValue('');
              inputSearch.current.focus();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RecipientsSearchBar;
